import React, { useEffect, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import CustomFileInput from '../../CustomFileInput';
import useUploadFiles from '../../../hooks/useUploadFiles';

const arquivoPermitido = (file, accept) => {
  const extensoes = accept
    .split(',')
    .map(extensao => extensao.trim().toLowerCase())
    .filter(Boolean);

  return extensoes.some(extensao => file.name.toLowerCase().endsWith(extensao));
};

const FileUploadModal = ({ show, onHide, atividade, accept }) => {
  const { setFiles, files, isUploading, confirmUpload } = useUploadFiles({
    atividade,
  });
  // Rastreia se havia arquivos quando o upload começou
  // Necessário para detectar quando o upload termina com sucesso
  const hadFilesRef = useRef(false);

  // Fecha o modal automaticamente quando:
  // - Upload terminou (!isUploading)
  // - Arquivos foram limpos (!hadFiles) - só acontece no sucesso
  // - Havia arquivos quando começou (hadFilesRef.current)
  useEffect(() => {
    const hadFiles = files && files.length > 0;
    if (hadFilesRef.current && !isUploading && !hadFiles && show) {
      hadFilesRef.current = false;
      onHide();
    }
  }, [isUploading, files, show, onHide]);

  const handleClose = () => {
    setFiles([]);
    onHide();
  };

  // Marca que havia arquivos antes do upload começar
  // O hook limpa files[] apenas no sucesso, então podemos detectar isso no useEffect
  const handleConfirm = async () => {
    if (files && files.length > 0) {
      hadFilesRef.current = true;
    }
    await confirmUpload();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="font-weight-bold">
        Anexar no laudo {atividade?.CODLAUDO}
      </Modal.Header>
      <Modal.Body>
        <CustomFileInput
          id="file-upload"
          label="Selecionar arquivo"
          multiple={true}
          accept={accept}
          onChange={e => {
            const selecionados = Array.from(e.target.files || []);
            if (!accept) {
              setFiles(selecionados);
              return;
            }

            const permitidos = selecionados.filter(file =>
              arquivoPermitido(file, accept)
            );
            if (permitidos.length !== selecionados.length) {
              toast.warn('Extensão de arquivo não permitida.');
            }
            setFiles(permitidos);
          }}
        />
        <ul>
          {files?.map(({ name }) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleConfirm} disabled={isUploading}>
          {isUploading ? 'Enviando...' : 'Confirmar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FileUploadModal;
